import { store } from "@/store/store";

export const planRestrictionsCheck = restriction => {
  const { planRestrictions } = store.state.auth;
  if (planRestrictions) {
    return planRestrictions[restriction];
  }

  return false;
};
